<div class="status-badge" [ngClass]="'status-' + status">
  <ion-icon *ngIf="status === CashFundStatusEnum.TRANSFERRED" name="arrow-forward-outline" class="arrow-icon"></ion-icon>
  <span class="px-4 py-4 fs-11 font-semibold text-uppercase">
    {{ 'pages.fund-cash.status.' + status | translate }}

    <ng-container *ngIf="status === CashFundStatusEnum.TRANSFERRED">
      {{ 'pages.fund-cash.transferredTo' | translate: { fullName: purchase.assignedUser?.name } }}
    </ng-container>
  </span>
</div>
